import { render, staticRenderFns } from "./activity-watcher.vue?vue&type=template&id=64d974e0"
import script from "./activity-watcher.vue?vue&type=script&lang=ts"
export * from "./activity-watcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports